<template>
  <GmapMap
    ref="map"
    :center="bookMap.options.center"
    :options="bookMap.options"
  >
    <GmapMarker
      v-if="bookMap.pickUp && bookMap.pickUp.lat && bookMap.pickUp.lng"
      key="pickUp"
      :position="bookMap.pickUp"
      :clickable="true"
      :icon="bookMap.pickUp.icon"
    />

    <GmapMarker
      v-if="bookMap.dropOff && bookMap.dropOff.lat && bookMap.dropOff.lng"
      key="dropOff"
      :position="bookMap.dropOff"
      :clickable="true"
      :icon="bookMap.dropOff.icon"
    />

    <DirectionsRenderer
      :origin="bookMap.pickUp"
      :destination="bookMap.dropOff"
      :directions-service-request-options="bookMap.directionsServiceRequestOptions"
      :directions-renderer-options="bookMap.directionsRendererOptions"
      @route-response="routeChanged"
    />

    <InfoWindow
      :opened="isBookMapInformerOpened"
      :position="bookMap.informer.position"
      :content="bookMap.informer.content"
    />
  </GmapMap>
</template>

<script>

import _ from 'lodash';

import { gmapApi } from 'vue2-google-maps';
import {
  mapMutations,
  mapState,
  mapActions,
  mapGetters,
} from 'vuex';
import { DirectionsRenderer, InfoWindow } from '@/components/Maps';
import { Map as MapUtils } from '@/utils';
import { DEFAULT_MAP_OPTIONS } from '@/constants';

// Store
import * as MapModule from './MapModule';

import { MAIN_DEFAULT_MAP_OPTIONS } from '../../../constants';

// Assets
// TODO: It should be a SVG or PNG depending of the browser compatibility
import pickUpIcon from '../../../assets/markers/icon-pick.png';
import dropOffIcon from '../../../assets/markers/location-pick.png';

export default {
  name: 'MapComponent',
  components: {
    DirectionsRenderer,
    InfoWindow,
  },
  computed: {
    ...mapState(MapModule.FULL_NAMESPACE, {
      bookMap: s => s.bookMap,
    }),
    ...mapGetters(MapModule.FULL_NAMESPACE, {
      isBookMapInformerOpened: MapModule.GETTERS.IS_BOOK_MAP_INFORMER_OPENED,
    }),
  },
  beforeMount() {
    this.bookMapSetOptions({
      ...DEFAULT_MAP_OPTIONS(gmapApi()),
      ...MAIN_DEFAULT_MAP_OPTIONS(gmapApi()),
      ...this.bookMap.options,
    });
    this.bookMapSetPickUpMarker({
      icon: pickUpIcon,
    });
    this.bookMapSetDropOffMarker({
      icon: dropOffIcon,
    });
    this.bookMapSetDirectionsServiceRequestOptions({
      travelMode: gmapApi().maps.TravelMode.DRIVING,
    });
    this.bookMapSetDirectionsRendererOptions({
      preserveViewport: false,
    });
  },
  methods: {
    ...mapMutations(MapModule.FULL_NAMESPACE, {
      bookMapSetOptions: MapModule.MUTATIONS.SET_BOOK_MAP_OPTIONS,
      bookMapSetPickUpMarker: MapModule.MUTATIONS.SET_PICK_UP_MARKER,
      bookMapSetDropOffMarker: MapModule.MUTATIONS.SET_DROP_OFF_MARKER,
      bookMapSetDirectionsServiceRequestOptions: MapModule.MUTATIONS.SET_DIRECTIONS_SERVICE_REQUEST_OPTIONS,
      bookMapSetDirectionsRendererOptions: MapModule.MUTATIONS.SET_DIRECTIONS_RENDERER_OPTIONS,
      bookMapSetInformerPosition: MapModule.MUTATIONS.SET_INFROMER_POSITION,
      bookMapSetInformerContent: MapModule.MUTATIONS.SET_INFORMER_CONTENT,
    }),
    ...mapActions(MapModule.FULL_NAMESPACE, {
      bookMapOpenInformer: MapModule.ACTIONS.OPEN_BOOK_MAP_INFORMER,
      bookMapCloseInformer: MapModule.ACTIONS.CLOSE_BOOK_MAP_INFORMER,
    }),
    routeChanged(route) {
      const data = MapUtils.getDataFromRoute(gmapApi(), route);
      if (_.isNil(data) && _.isNil(data.midpoint) && !_.isNumber(data.midpoint.lat()) && !_.isNumber(data.midpoint.lng())) {
        return;
      }
      this.bookMapSetInformerPosition({
        lat: data.midpoint.lat(),
        lng: data.midpoint.lng(),
      });

      this.bookMapSetInformerContent(data.totalDuration.text);

      this.$nextTick(() => {
        this.bookMapOpenInformer();
      });
    },
  },
};

</script>
